import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import EditIcon from "@mui/icons-material/Edit";
import { IIncrementalTableReport } from "../../../Interfaces/deltaHedgeSettings";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setAddEditIncrementalFormValues,
  setHeltaHedgeSettingsAddEditModalFlag,
  setIncrementalEditFlag,
  setIncrementalTableFlag,
} from "../../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import { useEffect } from "react";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IIncrementalTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const dispatch = useAppDispatch();
  const flag = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.incrementalTableRefetchFlag
  );
  const editHandler = () => {
    dispatch(setAddEditIncrementalFormValues(row));
    dispatch(setIncrementalEditFlag(true));
    dispatch(setHeltaHedgeSettingsAddEditModalFlag(true));
  };

  useEffect(() => {
    if (flag) {
      onAction();
      dispatch(setIncrementalTableFlag(false));
    }
  }, [flag]);

  return (
    <>
      <TableCell>
        <div className="w-32">
          <Button
            text={<EditIcon className="!text-sm" />}
            variant="contained"
            className="table-btn"
            onClick={editHandler}
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IIncrementalTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
